import { useEffect, useState, useRef } from "react"
import TeamBuilder from "../../components/TeamBuilder/Index"
import { useNavigate, useParams } from "react-router-dom"
import { fetchAdminCompetition, fetchAdminCompetitionEvent } from "../../api/admin/api"
import { initializeTeam, deactivateTeam, updateCompetitionTeam } from "../../api/api"

export default function CreateTeam() {
  const { competition_id, competition_event_id, editingTeam, team_id } = useParams()
  const [competition, setCompetition] = useState(null)
  const [competitionEvent, setCompetitionEvent] = useState(null)
  const [team, setTeam] = useState(null)
  const navigate = useNavigate()
  const hasDeactivated = useRef(false)
  const isEditing = editingTeam === 'true'

  console.log('Test Build 8/26/2025')

  const handleTeamSubmit = async (teamPayload) => {
    let res;
    if (teamPayload.isEditing) {
      res = await updateCompetitionTeam({
        id: teamPayload.editingTeamId,
        name: teamPayload.name,
        division_selection: teamPayload.division_selection,
        address: teamPayload.address,
        office_name: teamPayload.office_name,
        office_restriction: teamPayload.office_restriction,
        division: teamPayload.division,
        creator_employee_id: teamPayload.creator_employee_id,
        last_modified_by: teamPayload.last_modified_by
      });
    } else {
      res = await initializeTeam({
        name: teamPayload.name,
        division_selection: teamPayload.division_selection,
        address: teamPayload.address,
        competition_event_id: teamPayload.competition_event_id,
        competition_id: teamPayload.competition_id,
        creator_employee_id: teamPayload.creator_employee_id,
        office_name: teamPayload.office_name,
        office_restriction: teamPayload.office_restriction,
        division: teamPayload.division,
        last_modified_by: teamPayload.last_modified_by
      });
    }

    navigate(`/admin/competitions/${res.competition_id}/competition_events/${res.competition_event_id}/competition_teams/${res.id}/editing/${editingTeam}`)
  };

  useEffect(() => {
    fetchAdminCompetition(competition_id).then(res => setCompetition(res))
    fetchAdminCompetitionEvent(competition_event_id).then(res => setCompetitionEvent(res))

    const handleBackButtonPressed = () => {
      // Don't allow them to leave the page. Force them to hit the submit
      const confirmLeave = window.confirm(
        "Are you sure you want to leave? Your team will remain removed from the google sheet. You must click `submit` to readd the team to the google sheet. Hit cancel to remain on the current page."
      );

      if (!confirmLeave) {
        // Cancel back navigation
        navigate(1)// Hacky way to cancel back nav and "stay" on page
      }
    }

    window.addEventListener('popstate', handleBackButtonPressed)

    return () => {
      window.removeEventListener('popstate', handleBackButtonPressed)
    }
  }, [])

  useEffect(() => {
    if (editingTeam === "true" && !hasDeactivated.current) {
      hasDeactivated.current = true;
      deactivateTeam(team_id);
    }
  }, [editingTeam, team_id]);

  return (
    <>
      {competition && competitionEvent ? 
      <TeamBuilder
        competition={competition}
        competition_event={competitionEvent}
        setTeam={setTeam}
        editingTeam={isEditing}
        editingTeamId={team_id}
        onSubmit={handleTeamSubmit}
      />
      : <p>Loading...</p>}
    </>
  )
}